import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  // tslint:disable-next-line
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'app-crew-dashboard-ctrl',
})
export class CrewDashboardComponentDirective extends UpgradeComponent {
  @Input() instructions: any;
  @Input() instructionGroups: any;
  @Input() notifications: any;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('crewDashboardComponent', elementRef, injector);
  }
}
